import React from "react";
import { Video } from "~/common/Store/models/Video";
import ZestVideoPlayer from "~/common/videoPlayer/ZestVideoPlayer";
export interface EmbeddedVideoProps {
  video: Video;
  height: number;
  width: number;
}
/* this component is meant only for use on the /v/ page which is used to embed videos.
    Use ZestVideoPlayer directly rather than use this component
*/
export const EmbeddedVideo = ({
  video,
  height,
  width
}: EmbeddedVideoProps) => {
  return <>
      {video ? <ZestVideoPlayer posterImage={video.poster} sources={video.sources} currentIndex={0} selected={0} activePlayer={false} youtubeId={video.youtubeId} useCdn playsInline closedCaptionsrc={video.closedCaptionFile} height={height} width={width} /> : <p> Sorry, video was not found!</p>}
    </>;
};
export default EmbeddedVideo;